import { ReactNode, SelectHTMLAttributes } from 'react'
import cn from 'classnames'
import { Chevron as ChevronIcon } from '../icons'
import { UseFormRegisterReturn } from 'react-hook-form'
import { InputLabel } from './InputLabel'

export interface DropdownProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string
  children?: ReactNode
  hideLabel?: boolean
  register?: UseFormRegisterReturn
  errorMessage?: string
}
export function Dropdown({
  id,
  label,
  hideLabel = false,
  required = false,
  children,
  register,
  disabled,
  className,
  errorMessage,
  ...props
}: DropdownProps): JSX.Element {
  return (
    <div className={cn('flex flex-col justify-start', className)}>
      <InputLabel
        htmlFor={id}
        label={label}
        required={required}
        hideLabel={hideLabel}
      />
      <div className="flex items-center">
        <select
          id={id}
          aria-label={label}
          name="dropdown"
          className={cn(
            '-mr-4 appearance-none text-primary bg-white focus:ring-focus h-10 inline-flex pl-3 pr-6 ring-2 ring-primary rounded-sm w-full',
            errorMessage && 'ring-error',
            disabled
              ? 'ring-primary-40 text-primary-40'
              : 'hover:ring-primary-60'
          )}
          {...register}
          {...props}
        >
          {children}
        </select>
        <ChevronIcon className="relative right-2" />
      </div>
      {errorMessage && (
        <span className="pt-1 text-error text-sm">{errorMessage}</span>
      )}
    </div>
  )
}
